import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

export default function WhatCanWeDoForYou() {
  const { t } = useTranslation();

  const dataList = [
    {
      title: 'Remove Leak Sources',
      desc: 'We tackle content leaks at their source, ensuring your creations are protected.',
      imgPath: '/images/protection/onlyfans-RemoveLeakSources-icon.webp',
    },
    {
      title: 'Google Listing Removal',
      desc: 'Prevent unauthorized access by keeping your content off search results.',
      imgPath: '/images/protection/onlyfans-GoogleListingRemoval-icon.webp',
    },
    {
      title: 'Deepfake Account Removal',
      desc: 'We’ll eliminate impersonating accounts that misuse your identity.',
      imgPath: '/images/protection/onlyfans-DeepfakeAccountRemoval-icon.webp',
    },
    {
      title: 'Effective Watermarking',
      desc: 'Establish your ownership with unique DMCA badge that deter theft.',
      imgPath: '/images/protection/onlyfans-EffectiveWatermarking-icon.webp',
    },
  ];

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>{t('What Can Erasa Do for OnlyFans Protection')}</h2>

      <div className={styles.offerGrid}>
        {dataList?.map((item, index) => {
          return (
            <div className={styles.offerItem} key={item?.title}>
              <Image src={item?.imgPath} alt={item?.title} width={76} height={76} loading="lazy" />
              <h3 className={styles.subTitle}>{t(item?.title)}</h3>
              <p className={styles.subDesc}>{t(item?.desc)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
